import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      redirect:"/bindDevice"
    },
    {
      path:"/login",
      name:"login",
      component:Login
    },
    {
      path:"/bindDevice",
      name:"bindDevice",
      component:()=>import("./views/bindDevice.vue")
    },
    {
      path:"/success",
      name:"success",
      component:()=>import("./views/success.vue")
    },
    {
      path:"/fail",
      name:"fail",
      component:()=>import("./views/fail.vue")
    }
  ]
})
